import { render, staticRenderFns } from "./ProjectCrsSelector.vue?vue&type=template&id=12919c5e&scoped=true&"
import script from "./ProjectCrsSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectCrsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCrsSelector.vue?vue&type=style&index=0&id=12919c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12919c5e",
  null
  
)

export default component.exports